import { render } from "./ConfirmFeedback.vue?vue&type=template&id=01b57911"
import script from "./ConfirmFeedback.vue?vue&type=script&lang=js"
export * from "./ConfirmFeedback.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__